/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Normally1Inputs */

const id_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const ms_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biasa`)
};

const da_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalt`)
};

const de_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const en_us2_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normally`)
};

const es_es2_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalmente`)
};

const es_mx2_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const fil_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const fr_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalement`)
};

const it_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalmente`)
};

const hu_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normál`)
};

const nl_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normaal`)
};

const no_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalt`)
};

const pl_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalnie`)
};

const pt_br2_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalmente`)
};

const pt_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalmente`)
};

const ro_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const fi_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normaalisti`)
};

const sv_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const vi_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bình thường`)
};

const tr_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const cs_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normálně`)
};

const bg_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нормално`)
};

const ru_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обычно`)
};

const uk_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зазвичай`)
};

const ar_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بشكل طبيعي`)
};

const hi_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामान्य रूप से`)
};

const th_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปกติ`)
};

const ja_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通常`)
};

const zh_cn2_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正常流程`)
};

const zh_hant1_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正常流程`)
};

const ko_offerdetail_overview_normally1 = /** @type {(inputs: Offerdetail_Overview_Normally1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보통`)
};

/**
* | output |
* | --- |
* | "Normally" |
*
* @param {Offerdetail_Overview_Normally1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_normally1 = /** @type {((inputs?: Offerdetail_Overview_Normally1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Normally1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_normally1(inputs)
	if (locale === "ms") return ms_offerdetail_overview_normally1(inputs)
	if (locale === "da") return da_offerdetail_overview_normally1(inputs)
	if (locale === "de") return de_offerdetail_overview_normally1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_normally1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_normally1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_normally1(inputs)
	if (locale === "fil") return fil_offerdetail_overview_normally1(inputs)
	if (locale === "fr") return fr_offerdetail_overview_normally1(inputs)
	if (locale === "it") return it_offerdetail_overview_normally1(inputs)
	if (locale === "hu") return hu_offerdetail_overview_normally1(inputs)
	if (locale === "nl") return nl_offerdetail_overview_normally1(inputs)
	if (locale === "no") return no_offerdetail_overview_normally1(inputs)
	if (locale === "pl") return pl_offerdetail_overview_normally1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_normally1(inputs)
	if (locale === "pt") return pt_offerdetail_overview_normally1(inputs)
	if (locale === "ro") return ro_offerdetail_overview_normally1(inputs)
	if (locale === "fi") return fi_offerdetail_overview_normally1(inputs)
	if (locale === "sv") return sv_offerdetail_overview_normally1(inputs)
	if (locale === "vi") return vi_offerdetail_overview_normally1(inputs)
	if (locale === "tr") return tr_offerdetail_overview_normally1(inputs)
	if (locale === "cs") return cs_offerdetail_overview_normally1(inputs)
	if (locale === "bg") return bg_offerdetail_overview_normally1(inputs)
	if (locale === "ru") return ru_offerdetail_overview_normally1(inputs)
	if (locale === "uk") return uk_offerdetail_overview_normally1(inputs)
	if (locale === "ar") return ar_offerdetail_overview_normally1(inputs)
	if (locale === "hi") return hi_offerdetail_overview_normally1(inputs)
	if (locale === "th") return th_offerdetail_overview_normally1(inputs)
	if (locale === "ja") return ja_offerdetail_overview_normally1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_normally1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_normally1(inputs)
	return ko_offerdetail_overview_normally1(inputs)
});
export { offerdetail_overview_normally1 as "offerDetail.overview.normally" }